import {combineReducers} from 'redux';
import { productReducer} from "./productReducer";

const reducers = combineReducers({
  channels: productReducer,
});

export default reducers;